module.exports = __webpack_public_path__ + "img/base.4b121dc3.webp";